import { Tooltip } from "./_bootstrap";

(function () {
  // * Tooltip initialization, remove it if not necessary
  document
    .querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach((tooltipElement) => new Tooltip(tooltipElement));
})();

window.addEventListener("DOMContentLoaded", (event) => {
  // Toggle the side navigation
  const sidebarToggle = document.body.querySelector("#sidebarToggle");
  const sidebarToggleMobile = document.body.querySelector(
    "#sidebarToggleMobile",
  );
  const checkbox = document.body.querySelector("#sidebar-toggle-checkbox");
  const checkboxMobile = document.body.querySelector(
    "#sidebar-toggle-checkbox-mobile",
  );
  const toggleClass = "sb-sidenav-toggled";

  document.body.classList.toggle(toggleClass);

  if (sidebarToggle) {
    sidebarToggle.addEventListener("click", (toggleEvent) => {
      toggleEvent.preventDefault();
      document.body.classList.toggle(toggleClass);
      checkbox.checked = !checkbox.checked;
      checkboxMobile.checked = !checkboxMobile.checked;
    });
  }

  if (sidebarToggleMobile) {
    sidebarToggleMobile.addEventListener("click", (toggleEventMobile) => {
      toggleEventMobile.preventDefault();
      document.body.classList.toggle(toggleClass);
      checkbox.checked = !checkbox.checked;
      checkboxMobile.checked = !checkboxMobile.checked;
    });
  }
});

(function ($, Drupal) {
  Drupal.behaviors.slickBehavior = {
    attach: function (context) {
      once("slickBehavior", "html", context).forEach(function () {
        const slider = $(".my-slick-slider");
        slider.slick({
          arrows: true,
          centerMode: true,
          slidesToShow: 3,
          variableWidth: true,
          draggable: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: true,
                centerMode: true,
                centerPadding: "40px",
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 480,
              settings: {
                arrows: true,
                centerMode: true,
                centerPadding: "40px",
                slidesToShow: 1,
                draggable: true,
              },
            },
          ],
        });
      });
    },
  };
})(jQuery, Drupal);

(function ($) {
  $(document).ready(function () {
    function selectCurrentSlide() {
      $(".slick-slide")
        .not(".slick-current")
        .children("div")
        .children("input")
        .attr("checked", false);
      $(".slick-current")
        .children("div")
        .eq(0)
        .children("input")
        .eq(0)
        .attr("checked", true);
    }
    selectCurrentSlide();
    $(".slick-slider").on(
      "afterChange",
      function (event, slick, currentSlide, nextSlide) {
        selectCurrentSlide();
      },
    );
  });
})(jQuery);

/** Listen for pasting on iban field and remove DE prefix while pasting */
(function ($) {
  $(document).ready(function () {
    $("#edit-iban").on("paste", function (e) {
      e.preventDefault();
      let pasted = e.originalEvent.clipboardData.getData("text");
      if (pasted.startsWith("DE")) {
        pasted = pasted.slice(2);
        pasted = pasted.replace(/\s+/g, "");
        $(this).val(pasted);
      }
    });
  });
})(jQuery);
